
<template>
    
        <mars-view v-if="lawyerInfo" class="lawyer-info" @click.native="clickConsult(0)"><mars-view class="avatar-box"><mars-image class="avatar-image" mode="heightFix" :lazy-load="true" :src="lawyerInfo.avatar"></mars-image><mars-view v-if="lawyerInfo.is_lvlin_lawyer" class="v-icon"></mars-view></mars-view><mars-view class="middle"><mars-view class="name"><mars-view class="name-text">
                {{ lawyerInfo.name }}
            </mars-view><template v-if="lawyerInfo.is_lvlin_lawyer && lawyerInfo.is_vip"><mars-view v-if="+lawyerInfo.vip_type === 7 || +lawyerInfo.vip_type === 8" class="young-vip-icon"></mars-view><mars-view v-else class="vip-icon"></mars-view></template></mars-view><mars-view v-if="lawyerInfo.is_lvlin_lawyer" class="position">
            {{ lawyerInfo.register_years ? '执业' + lawyerInfo.register_years + '年' : lawyerInfo.lawyer_position }} | {{ lawyerInfo.register_law_firm }}
        </mars-view></mars-view><mars-view :class="[
            'consult-btn', lawyerInfo.is_vip && lawyerInfo.is_lvlin_lawyer ? 'vip' : '',
            lawyerInfo.is_lvlin_lawyer ? 'isLvlin' : '',
        ]" @click.native.stop="clickConsult(1)">
        {{ lawyerInfo.is_lvlin_lawyer ? '咨询' : '咨询专线' }}
    </mars-view></mars-view>
    
</template>

<script>
import { act } from '../../../static/utils/navigate';
import log from '../../../static/utils/ubcLog';
export default {
  name: 'lawyerInfo',
  props: {
    lawyerInfo: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    /**
     * 跳转律师主页
     * @param {Number} isConsult 是否点击咨询
     */

    clickConsult(isConsult) {
      // 作者信息区域点击
      log.send && log.send({
        serverId: 17291,
        area: isConsult ? 'zuozhe_icon_click' : 'zuozhe_click',
        action: 'click',
        is_lvlin_lawyer: this.lawyerInfo.is_lvlin_lawyer // 是否是入驻律师
      });
      // 由于有 stop,这里要补充一下
      log.send({
        serverId: 17291,
        area: 'all_click',
        action: 'click'
      });
      if (!this.lawyerInfo.is_lvlin_lawyer) {
        this.$emit('openConsultForm');
        return;
      }
      let url = `/pages/experthome/index?qc_no=${this.lawyerInfo.qc_no}&fr=note_lawyer`;
      act({
        type: 'url',
        target: isConsult ? url + '&action=consult' : url
      });
    }
  }
};
</script>

<style scoped>
.lawyer-info {
  display: flex;
  padding: 0.2rem 0.17rem 0;
  align-items: center;
}
.lawyer-info .avatar-box {
  height: 0.35rem;
  width: 0.35rem;
  border-radius: 50%;
  background-image: linear-gradient(-39deg, #9ea0b1 0%, #c7c9d5 99%);
  position: relative;
}
.lawyer-info .avatar-box .avatar-image {
  height: 100%;
  width: 100% !important;
  border-radius: 50%;
}
.lawyer-info .avatar-box .avatar-image /deep/ [class*="image-inner"] {
  background-size: auto 100%;
  background-position: center;
}
.lawyer-info .avatar-box .v-icon {
  width: 0.16rem;
  height: 0.16rem;
  position: absolute;
  right: -0.02rem;
  bottom: -0.02rem;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/exporthome/light.png') no-repeat;
  background-size: 100% 100%;
}
.lawyer-info .middle {
  margin-left: 0.08rem;
  color: #858585;
  font-family: PingFang SC;
  font-size: 0.11rem;
  font-weight: 400;
}
.lawyer-info .middle .name {
  font-family: PingFang SC;
  height: 0.16rem;
  display: flex;
}
.lawyer-info .middle .name .name-text {
  color: #1f1f1f;
  font-size: 0.15rem;
  font-weight: 500;
  line-height: 0.18rem;
}
.lawyer-info .middle .name .young-vip-icon {
  width: 0.45rem;
  height: 0.16rem;
  background: url("https://lvlin-base.cdn.bcebos.com/law/pages/exporthome/young-vip-member.png") no-repeat center center / contain;
  margin-left: 0.05rem;
}
.lawyer-info .middle .name .vip-icon {
  width: 0.45rem;
  height: 0.16rem;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/note/vip.png') no-repeat center center / contain;
  margin-left: 0.05rem;
}
.lawyer-info .middle .position {
  margin-top: 0.06rem;
  line-height: 1;
}
.lawyer-info .consult-btn {
  height: 0.3rem;
  background: #05f;
  color: #fff;
  font-family: PingFang SC;
  font-size: 0.13rem;
  font-weight: 500;
  line-height: 0.31rem;
  text-align: center;
  position: absolute;
  right: 0.17rem;
  border-radius: 0.18rem;
  padding: 0 0.13rem;
}
.lawyer-info .consult-btn.vip {
  background: #fed9b9;
  color: #401611;
}
.lawyer-info .consult-btn.isLvlin {
  padding: 0 0.2rem;
}

</style>
